<script lang="tsx">
import BaseEditableHolder from "@primevue/core/baseeditableholder";
import EditorStyle from "./EditorStyle";

export default {
  name: "BaseEditor",
  extends: BaseEditableHolder,
  props: {
    placeholder: String,
    readonly: Boolean,
    formats: Array,
    editorStyle: null,
    modules: null
  },
  style: EditorStyle,
  provide() {
    return {
      $pcEditor: this,
      $parentInstance: this
    };
  }
};
</script>
